"use client";

import { Separator as SeparatorPrimitive } from "@base-ui/react/separator";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@/lib/utils";

const separatorVariants = cva(
  "shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px",
  {
    variants: {
      weight: {
        subtle: "bg-grey-100",
        default: "bg-grey-200",
        strong: "bg-grey-950",
      },
    },
    defaultVariants: { weight: "default" },
  }
);

type SeparatorProps = React.ComponentPropsWithoutRef<
  typeof SeparatorPrimitive
> &
  VariantProps<typeof separatorVariants>;

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive>,
  SeparatorProps
>(({ className, orientation = "horizontal", weight, ...props }, ref) => (
  <SeparatorPrimitive
    ref={ref}
    orientation={orientation}
    className={cn(separatorVariants({ weight }), className)}
    {...props}
  />
));
Separator.displayName = SeparatorPrimitive.displayName;

export { Separator, separatorVariants };
